import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Broom } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../../lib/api";

export const CleanupTestPatients = ({ onDone }) => {
  const [count, setCount] = useState(0);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/test-patients").then(({ data }) => setCount(data.count)).catch(() => {});
  }, []);

  if (!count) return null;

  const purge = async () => {
    if (!window.confirm(`Permanently delete ${count} test patient profiles (emails ending @example.com) and their documents? Real patients are not affected.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/test-patients/purge");
      toast.success(`Deleted ${data.deleted} test profiles.`);
      setCount(0);
      onDone?.();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" onClick={purge} disabled={busy} data-testid="admin-cleanup-test-patients"
      className="btn-secondary inline-flex items-center gap-1.5">
      <Broom size={16} /> {busy ? "Deleting…" : `Delete ${count} test profiles`}
    </button>
  );
};
